import { $t } from '@/i18n'
import { reactive, ref } from 'vue'

export const queryForm = reactive({
  formItems: [
    {
      key: 'name',
      type: 'input',
      label: $t('storeModules.operationLog.storeName'),
      placeholder: $t('common.pleaseInput')
    },
    {
      key: 'org_id',
      label: $t('common.org'),
      placeholder: $t('common.pleaseSelect'),
      scopedSlots: 'org_id'
    }
  ]
})
export const columns = [
  {
    minWidth: 10,
    fixed: 'left',
    type: 'selection',
    reserveSelection: true
  },
  {
    prop: 'shop_name',
    label: $t('storeModules.operationLog.storeName'),
    showOverflowTooltip: true
  },
  {
    prop: 'cabinet_code',
    label: $t('storeModules.operationLog.cabinetId'),
    formatter: (_, __, text) => text || '--'
  },
  {
    prop: 'org_name',
    label: $t('common.org'),
    showOverflowTooltip: true

  }

]

export const hasColumns = () =>[
  {
    prop: 'shop_name',
    label: $t('storeModules.operationLog.storeName'),
    minWidth: 120,
    showOverflowTooltip: true
  },
  {
    prop: 'cabinet_code',
    label: $t('storeModules.operationLog.cabinetId'),
    minWidth: 100,
    formatter: (_, __, text) => text || '--'
  },
  {
    prop: 'org_name',
    label: $t('common.org'),
    minWidth: 120,
    showOverflowTooltip: true
  },
  {
    prop: 'operation',
    label: $t('common.operator'),
    minWidth: 80,
    scopedSlots: 'operation'
  }
]
